<div class="seed-return-add-prod" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Add Failed Product(s) to Request
    </h3>

    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-12 col-lg-12 smallPadRgt0">
          <app-filter [optionsData]="filterOptionsData" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 tabBgColor padding-t20">
      <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>
                Your Account Invoiced Products
              </h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer accInvProdTable">
            <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info cursor-defualt">
                  <p>{{element.itemVendorName}}</p>
                  <p class="grower-name">  {{element.itemDescription}}</p>
                  <p class="itemNumber"> {{element.itemNumber}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="Available Units">
                <th mat-header-cell *matHeaderCellDef class="text-center availableUnits"> Eligible Units </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.eligibleUnits}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.packageSizeDesc}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Technology">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Technology </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.technology}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Treatment">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Treatment </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.treatmentDescription}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine"> Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <span>{{element.productLine}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="LotNumber">
                <th mat-header-cell *matHeaderCellDef class="text-center lotNoBlock"> Lot# </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span>{{element.lotNumber}}</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,false)"></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>Parent Company Invoiced Products</h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer compInvProdTable">
            <table mat-table [dataSource]="parentAccountDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info">
                  <p>{{element.itemVendorName}} </p>
                  <p class="grower-name">{{element.itemDescription}}</p>
                  <p class="itemNumber"> {{element.itemNumber}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="Available Units">
                <th mat-header-cell *matHeaderCellDef class="text-center availableUnits"> Eligible Units </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.eligibleUnits}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.packageSizeDesc}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Technology">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Technology </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.technology}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Treatment">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Treatment </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>{{element.treatmentDescription}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <span>{{element.productLine}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="LotNumber">
                <th mat-header-cell *matHeaderCellDef class="text-center lotNoBlock"> Lot# </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span>{{element.lotNumber}}</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,true)"></tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-md-2 padding-l0">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
    </div>
    <div class="col-md-10 text-right">
      <span class="count">Product selected <span>{{selectedProductList.length}}</span></span>
    </div>
  </div>
</div>
